export default __webpack_public_path__ + "static/media/my.31aefbea.svg";